<template>
    <v-form @submit.prevent="saveRecipients" ref="form">
        <v-card class="elevation-1 rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">Add Recipients</span>
                <v-spacer></v-spacer>
                 <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-progress-linear v-if="loading_uploading" indeterminate height="2" class="mt-0"></v-progress-linear>

            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support. {{errorMessage}}
            </v-alert>  

            <v-card-text>
                <!-- Version Label, Recipient-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-select
                            label="Recipient Type"
                            :items="recipient_types"
                            :rules="[rules.required]" 
                            :disabled="disabled"
                            item-text="description"
                            item-value="recipientType"
                            v-model="recipientType"
                        ></v-select>
                    </v-flex>
                </v-layout>
                
                <!-- by teams -->
                <v-layout v-if="recipientType==2" row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-autocomplete
                            v-model="teamIds"
                            :disabled="disabled"
                            :items="teams"
                            :loading="loading_teams"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Selecte Teams"
                            item-text="name"
                            item-value="teamId"
                            multiple
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi ml-0">
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>

                <!-- by employees -->
                <v-layout v-if="recipientType==3" row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-autocomplete
                            v-model="userIds"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Select Employees"
                            item-text="name"
                            item-value="userId"
                            multiple
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi ml-0">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="mr-25">
                <v-spacer></v-spacer>
                <v-btn type="submit" class="primary" :disabled="disabled||loading||!completeFormData" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>

    </v-form>
</template>
<script>
    
import companyAnnouncementsApi from '@/api/companyannouncements'
import teamsApi from '@/api/team'
import employeeApi from '@/api/employees'
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    name: 'AddRecipients',
    components: {},
    data () {
        return {
            error: false,
            errorMessage: '',
            disabled: false,
            loading: false,
            loading_uploading: false,
            loading_employees: false,
            loading_teams: false,

            //put this in rules-helper.js
            rules: {
                required: value => !!value || 'Required.',
                required_list: value => !!value.length || 'Required.',
                required_multiple: value => value.length>0 || 'Must select at least one month.',
            },
            recipient_types: [
                { recipientType: 1, description: 'All Employees' },
                { recipientType: 2, description: 'Selected Teams' },
                { recipientType: 3, description: 'Selected Employees' }
            ],
            employees: [],
            teams: [],
            companyAnnouncementId: null,
            recipientType: null,
            teamIds: [],
            userIds: [],
        }
    },
    methods: {
        async saveRecipients() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate() && this.completeFormData) {
                    const data = {
                        companyAnnouncementId: this.companyAnnouncementId,
                        recipientType: this.recipientType,
                        teamIds: this.teamIds,
                        userIds: this.userIds
                    }
                    const response = await companyAnnouncementsApi.addRecipients(data)
                    if (response && response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getTeams() {
            try {
                this.loading_teams = true
                const response = await teamsApi.getTeamsByCompany(false)
                if (response && response.status == 200) {
                    this.teams = response.data.items
                }
                this.loading_teams = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAllByPageKey(pageKeys.company_announcements)
                if (response && response.status == 200) {
                    const filtered = response.data.employees
                    filtered.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            firstName: item.firstName,
                            lastName: item.lastName,
                            email: item.email,
                            group: item.team
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        setAdd(companyAnnouncementId) {
            this.companyAnnouncementId = companyAnnouncementId
            this.clearForm()
            this.initializeData()
        },
        async initializeData() {
            if (!this.teams.length) {
                await this.getTeams()
            }
            if (!this.employees.length) {
                await this.getEmployees()
            }
        },
        async closeDialog() {
            this.$emit('update:dialogAddRecipients', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.error = false
            this.errorMessage = ''
            this.loading = false
        },
    },
    computed: {
        completeFormData() {
            return this.recipientType == 1 ||
                (this.recipientType == 2 && this.teamIds.length) ||
                (this.recipientType == 3 && this.userIds.length)
        },
    }
}
</script>
<style scoped>
.form-content {
    padding:0px 20px 0px 20px;
    margin-top:-5x;
}
.form-upload {
    height:150px;
    margin:15px 0px 10px 0px;
    padding:0px 50px 0px 50px;
    border: 1px dashed darkgray
}
.delete-container {
    float:right;
    margin-top:-10px;
}
.uploaded {
    margin-top: 15px;
}
</style>